if (!customElements.get('rbf-boutique')) {
  customElements.define('rbf-boutique', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.cards = [...this.querySelectorAll('[data-rbf-category]')];
      this.buttons = [...this.querySelectorAll('[data-rbf-filter]')];
      this.motionButton = this.querySelector('[data-rbf-motion]');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motionAllowed = this.dataset.motionEnabled !== 'false';
      this.motionPaused = false;
      try { this.motionPaused = localStorage.getItem('rbf-gallery-motion') === 'paused'; } catch {}
      this.updateMotion();
      this.reducedMotion.addEventListener('change', () => this.updateMotion(), { signal });
      this.motionButton?.addEventListener('click', () => {
        this.motionPaused = !this.motionPaused;
        try { localStorage.setItem('rbf-gallery-motion', this.motionPaused ? 'paused' : 'playing'); } catch {}
        this.updateMotion();
      }, { signal });
      this.classList.add('is-ready');
      const count = this.querySelector('[data-rbf-count]');
      const empty = this.querySelector('[data-rbf-empty]');
      for (const button of this.buttons) {
        button.addEventListener('click', () => {
          const applyFilter = () => {
            let visible = 0;
            for (const card of this.cards) {
              card.hidden = button.dataset.rbfFilter !== 'all' && card.dataset.rbfCategory !== button.dataset.rbfFilter;
              if (!card.hidden) visible++;
            }
            for (const item of this.buttons) item.setAttribute('aria-pressed', String(item === button));
            if (count) count.textContent = String(visible);
            if (empty) empty.hidden = visible !== 0;
          };
          if (this.motionOn && document.startViewTransition) {
            this.transition?.skipTransition();
            this.transition = document.startViewTransition(applyFilter);
          } else applyFilter();
        }, { signal });
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            entry.target.classList.toggle('is-in-view', entry.isIntersecting);
            if (entry.isIntersecting && !entry.target.dataset.revealed) {
              entry.target.dataset.revealed = 'true';
              if (this.motionOn) entry.target.animate([
                { opacity: 0.45, transform: 'translateY(22px)' },
                { opacity: 1, transform: 'translateY(0)' }
              ], { duration: 650, delay: Number(entry.target.style.getPropertyValue('--rbf-sequence')) * 70, easing: 'cubic-bezier(.2,.65,.3,1)' });
            }
          }
        }, { threshold: 0.12 });
        for (const card of this.cards) this.observer.observe(card);
      }
      this.querySelectorAll('.rbf-gallery-frame').forEach(frame => {
        let bounds;
        const reset = () => {
          frame.style.removeProperty('--rbf-tilt-x');
          frame.style.removeProperty('--rbf-tilt-y');
          frame.style.removeProperty('--rbf-light-x');
        };
        frame.addEventListener('pointerenter', () => { bounds = frame.getBoundingClientRect(); }, { signal });
        frame.addEventListener('pointermove', event => {
          if (!this.motionOn || event.pointerType !== 'mouse' || !bounds) return;
          const x = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
          const y = Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height));
          frame.style.setProperty('--rbf-tilt-x', `${(0.5 - y) * 4}deg`);
          frame.style.setProperty('--rbf-tilt-y', `${(x - 0.5) * 4}deg`);
          frame.style.setProperty('--rbf-light-x', `${x * 100}%`);
        }, { signal, passive: true });
        frame.addEventListener('pointerleave', reset, { signal });
        frame.addEventListener('blur', reset, { signal });
      });
      document.addEventListener('visibilitychange', () => this.classList.toggle('is-document-hidden', document.hidden), { signal });
    }
    updateMotion() {
      this.motionOn = this.motionAllowed && !this.motionPaused && !this.reducedMotion.matches;
      this.dataset.motion = this.motionOn ? 'on' : 'off';
      if (this.motionButton) {
        this.motionButton.hidden = !this.motionAllowed || this.reducedMotion.matches;
        this.motionButton.setAttribute('aria-pressed', String(this.motionOn));
        this.motionButton.textContent = this.motionOn ? this.motionButton.dataset.labelOn : this.motionButton.dataset.labelOff;
      }
      if (!this.motionOn) this.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.transition?.skipTransition();
    }
  });
}
